module.exports = __webpack_public_path__ + "static/media/calendar_3.3e276e12.svg";